import moment from "moment";
export function parseDate(d) {
    if (d == null)
        return null;
    return moment(d).local().toDate();
}
export function formatDateHuman(d) {
    if (d == null)
        return "";
    let md = moment(d);
    if (md.year() == 1900)
        return "";
    return md.format('DD/MM/YYYY');
}
export function formatTimestampHuman(d) {
    if (d == null)
        return "";
    return moment(d).format('DD/MM/YYYY HH:mm');
}
export function formatCurrency_old(val) {
    return '€ ' + (val || 0).toFixed(2);
}
export function formatCurrency(val) {
    if (val == null || val == "")
        val = 0;
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 })
        .format(val);
}
//new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits: 2})
//.format(record.invoice.importo)
